<template>
  <div id="app">
    <section class="hero is-dark">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Vudu Crew</h1>
          <h2 class="subtitle">Comprehensive Listing</h2>
        </div>
      </div>
    </section>
    <div class="container is-fluid main">
      <section>
        <b-field grouped group-multiline>
          <div class="control is-flex header">
            <b-field>
              <b-select
              placeholder="Select an Account"
              size="is-large"
              v-model="account"
              v-on:input="loadNewAccount">
                <option
                  v-for="account in accounts"
                  :value="account"
                  :key="account"
                >
                  {{ account.capitalize() }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="control is-flex header movie-switch">
            <b-switch v-model="showingMovies">
              {{ showingMovies ? "Showing Movies" : "Showing TV" }}
            </b-switch>
          </div>
          <div class="control is-flex header app-info" v-if="tableData.length">
            Updated: {{ dateUpdated }} 
          </div>
          <div class="control is-flex header app-info" v-if="tableData.length">
            Total Records: {{ tableData.length }}
          </div>
          <div class="control is-flex header app-info" v-if="tableData.length">
            Total Unique Movies: {{ totalUniqueMovies }}
          </div>
        </b-field>
        <b-table
        :data="purchases"
        :narrowed="true"
        :striped="true"
        :paginated="true"
        :per-page="23"
        :loading="loading"
        >
          <template slot-scope="props">
            <b-table-column field="purchaseTime" label="Date/Time Acquired" width="200" numeric sortable>
              {{ convertPurchaseTime(props.row.purchaseTime) }}
            </b-table-column>
            <b-table-column field="content.title" label="Title" width="500" searchable sortable>
              {{ props.row.content.title }}
            </b-table-column>
            <b-table-column field="content.contentVariants.contentVariant.videoQuality" label="Purchased Quality" searchable centered width="180">
              <span :class="createQualityClassStr(props.row.content.contentVariants.contentVariant.videoQuality)">
                {{ props.row.content.contentVariants.contentVariant.videoQuality.toUpperCase() }}
              </span>
            </b-table-column>
            <b-table-column field="content.bestStreamableVideoQuality" label="Best Quality on Vudu" searchable centered width="180">
              <span :class="createQualityClassStr(props.row.content.bestStreamableVideoQuality)">
                {{ createQualityStr(props.row.content.bestStreamableVideoQuality) }}
              </span>
            </b-table-column>
            <b-table-column field="licenseSeconds" label="Rental" centered>
              <span v-if="props.row.hasOwnProperty('licenseSeconds')" class="tag is-light is-warning">
                YES
              </span>
            </b-table-column>
            <b-table-column field="price" label="Price Paid" numeric>
              {{ toCurrency(props.row.price) }}
            </b-table-column>
            <b-table-column field="content.releaseTime" label="Release Date" numeric sortable>
              {{ convertReleaseTime(props.row.content.releaseTime) }}
            </b-table-column>
          </template>
        </b-table>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

export default {
  name: 'App',
  components: {
    
  },
  data: function () {
    return {
      account: null,
      accounts: ["seth", "grant", "charles", "andy"],
      showingMovies: true,
      loading: false,
      tableData: [],
      dateCreated: null
    }
  },
  mounted () {
    this.account = "seth"
    this.loadNewAccount()
  },
  computed: {
    dateUpdated() {
      return moment(this.dateCreated, "YYYY-M-D").format("M/D/YY")
    },
    purchases() {
      let purchases = this.tableData

      if (this.showingMovies) {
        purchases = purchases.filter(purchase => purchase.content.type != "episode")
      } else {
        purchases = purchases.filter(purchase => purchase.content.type == "episode")
      }
      
      return purchases
    },
    totalUniqueMovies() {
      let purchases = this.tableData
      purchases = purchases.filter(purchase => purchase.content.type != "episode" && !Object.prototype.hasOwnProperty.call(purchase, "licenseSeconds"))

      let titles = purchases.map(purchase => purchase.content.title)
      let uniqueTitles = Array.from(new Set(titles))

      return uniqueTitles.length
    },
    totalMoney() {
      let total = this.tableData.reduce(((a, purchase) => a + parseFloat(purchase.price)), 0)
      return "$" + total.toFixed(2)
    }
  },
  methods: {
    loadNewAccount: function () {
      this.loading = true
      axios.get(this.account + ".json")
      .then(response => this.parseResponse(response.data))
    },
    parseResponse: function (data) {
      this.dateCreated = data.dateCreated
      this.tableData = data.contents
      this.loading = false
    },
    convertPurchaseTime: function (str) {
      return moment.utc(str).local().format("MMM D, YYYY | h:mma")
    },
    convertReleaseTime: function (str) {
      return moment(str).format("MMM, D, YYYY")
    },
    createQualityStr: function (str) {
      if (!str) {
        return "Not Indicated"
      } else {
        return str.toUpperCase()
      }
    },
    createQualityClassStr: function (str) {
      let classStr = "tag is-light "

      if (str == "hdx") {
        classStr += "is-success"
      } else if (str == "uhd") {
        classStr += "is-info"
      } else if (str == "sd") {
        classStr += "is-warning"
      }

      return classStr
    },
    toCurrency: function (str) {
      return "$" + parseFloat(str).toFixed(2)
    }
  }
}
</script>

<style>
div.hero-body {
  padding-top: 20px;
  padding-bottom: 20px;
}

div.container.main {
  margin-top: 20px;
}

div.control.header {
  margin-right: 30px !important;
}

div.control.movie-switch {
  width: 180px;
}

div.control.header.app-info {
  font-size: 0.8em;
  margin-top: 18px !important;
}

.tag:not(body).is-info.is-light {
    background-color: #d5edff;
    color: #1d72aa;
}

.tag:not(body).is-success.is-light {
    background-color: #daf7e4;
    color: #257942;
}

.tag:not(body).is-warning.is-light {
    background-color: #fffbeb;
    color: #947600;
}

</style>
